import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AsyncThunkConfig, RootState } from '../store';

import {
    AddActionCases,
    GenericSliceState,
    HandleAsyncActionError,
} from '../../utils/helpers/reduxToolkitHelper';

export interface PricesState extends GenericSliceState {
    // general
    isLoading: boolean;
    errorCode: string | null;
    errorMessage: string;
    ethPriceUsd: number;
}

export const initialState: PricesState = {
    // general
    isLoading: false,
    errorCode: null,
    errorMessage: '',
    ethPriceUsd: 0,
};

// ------------- //
// Async Actions //
// ------------- //

export const fetchEthPriceUsd = createAsyncThunk<number, void, AsyncThunkConfig>(
    'coingecko/fetchEthPriceUsd',
    async (_, thunkAPI) => {
        try {
            const result = await thunkAPI.extra.prices.fetchEthPriceUsd();
            return result;
        } catch (err: any) {
            return HandleAsyncActionError(err, thunkAPI);
        }
    },
);


// ----- //
// Slice //
// ----- //

export const pricesSlice = createSlice({
    name: 'prices',
    initialState,
    reducers: {
        // -------------- //
        // Sync Reducers //
        // -------------- //

        clearPrices: (state, action: PayloadAction<void>) =>
            Object.assign(state, initialState),
    },
    extraReducers: (builder) => {
        // -------------- //
        // Async Reducers //
        // -------------- //

        
        AddActionCases(
            builder,
            fetchEthPriceUsd,
            (state, action) => {
                state.ethPriceUsd = action.payload;
            },
            (state, action) => {
                state.ethPriceUsd = 0;
            },
            (state, action) => {},
        );

    },
});

// ------------ //
// Sync Actions //
// ------------ //
export const { clearPrices } = pricesSlice.actions;

export const statsSelector = (state: RootState) => state.prices;
export default pricesSlice.reducer;
